import PropTypes from 'prop-types';
import React from 'react';
import PersonPill from './PersonPill';
import PeopleList from './PeopleList';
import './PeoplePicker.css';

class PeoplePicker extends React.Component {
  state = {
    selectedUserIds: new Set(),
  };

  handleUserClick = userId => {
    this.state.selectedUserIds.has(userId)
      ? this.deselectUser(userId)
      : this.selectUser(userId);
  };

  setUserIds(selectedUserIds) {
    this.setState({selectedUserIds}, () => {
      this.props.onUserIdsChange([...this.state.selectedUserIds]);
    });
  }

  selectUser(userId) {
    if (this.props.allowMultiple) {
      this.setUserIds(new Set(this.state.selectedUserIds).add(userId));
    } else {
      this.setUserIds(new Set([userId]));
    }
  }

  deselectUser(userId) {
    const selectedUserIds = new Set(this.state.selectedUserIds);
    selectedUserIds.delete(userId);
    this.setUserIds(selectedUserIds);
  }

  render() {
    const {onSearch} = this.props;

    const pills = [...this.state.selectedUserIds].map(id => (
      <PersonPill
        userId={id}
        key={id}
        onCloseClick={this.deselectUser.bind(this, id)}
      />
    ));

    return (
      <div>
        <div className="PeoplePicker__Pills">{pills}</div>
        <PeopleList
          onAccountClick={this.handleUserClick}
          selected={this.state.selectedUserIds}
          onSearch={onSearch}
        />
      </div>
    );
  }
}

PeoplePicker.propTypes = {
  onSearch: PropTypes.func,
  onUserIdsChange: PropTypes.func.isRequired,
  allowMultiple: PropTypes.bool.isRequired,
};

PeoplePicker.defaultProps = {
  allowMultiple: true,
};

export default PeoplePicker;
